<template>
    <section>
        <div class="container">
            <div class="row justify-center">
                <div class="col-xs-12 col-sm-10">
                    <div class="text-title">Revision History</div>
                    <q-card class="q-mb-lg">
                        <q-card-section :class="{'q-px-xl' : screenSize.gt.sm, 'q-px-md' : screenSize.lt.md}">
                            <img :src="form.productLine.logo" class="img-revision-history q-mt-md q-mb-sm" :title="form.productLine.name" />
                            <p>Choose your product to browse the Revision History</p>
                            <div class="row">
                                <div class="col-xs-12 col-sm-6 col-md-4">
                                    <q-select outlined dense class="col-xs-12 col-sm-6 col-md-3 q-mb-md"
                                              bg-color="white"
                                              label="Product Type" stack-label
                                              autocomplete="off"
                                              @input="updateOptions"
                                              v-model="form.productLine" :options="productLines"
                                              option-label="name"
                                              hide-bottom-space />
                                </div>
                            </div>
                            <div class="row">
                                <div v-if="form.productLine.name == 'LoopCAD'" class="col-xs-12 col-sm-6 col-md-4">
                                    <q-select outlined dense class="col-xs-12 col-sm-6 col-md-3 q-mb-md"
                                              bg-color="white"
                                              label="OEM Edition" stack-label
                                              autocomplete="off"
                                              @input="updateOptions"
                                              v-model="form.oemAddOn" :options="oems"
                                              option-label="name"
                                              :loading="getOemsPending"
                                              hide-bottom-space />
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </div>
            </div>
            <div class="q-my-lg">
                <div v-if="form.productLine" class="row justify-center q-mb-md">
                    <div class="q-col-gutter-lg justify-center col-xs-12 col-sm-10">
                        <div class="text-h6 q-mb-md">
                            Revision Notes
                        </div>
                        <div v-for="revision in revisions">
                            <revision-notes :revision="revision" :isRevHistoryPage="true" />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { mapState } from 'vuex'
    import { productLines } from '@/plugins/productLines'
    import revisionNotes from '@/components/RevisionNotes'

    export default {
        name: "revision-history",
        components: {
            revisionNotes,
        },
        props: {
            productLineParam: String
        },
        data() {
            return {
                productLines: Object.keys(productLines)?.map(key => {
                    return productLines[key]
                })?.filter(pl => pl.name.toLowerCase() !== 'lengthwise'),
                oems: [],
                form: {
                    productLine: null,
                    oemAddOn: null,
                },
                revisions: [],
            }
        },
        methods: {
            updateOptions() {
                if (this.form.productLine.name.toLowerCase() !== 'loopcad') {
                    this.form.oemAddOn = null;
                } else if (!this.form.oemAddOn) {
                    this.form.oemAddOn = this.oems?.find(o => o.name == 'Generic');
                }

                this.updateRoute();
                this.getRevisions();
            },
            getOEMs() {
                this.oems = [];
                return this.$store.dispatch('getOEMs').then(() => {
                    this.oems = this.getOemsData?.filter(function (o) { return o.productCategoryID == 'LoopCAD'; });
                })
            },
            getRevisions() {
                this.revisions = [];

                var productLine = this.form.productLine?.name;
                var oemAddOn = this.form.oemAddOn?.id;

                const versionPayload = {
                    productCategoryId: productLine,
                    oemAddOn: oemAddOn,
                };
                this.$store.dispatch('getVersions', versionPayload).then(() => {
                    var versions = this.getVersionsData;
                    versions.forEach((version) => {
                        const revisionPayload = {
                            productCategoryId: productLine,
                            version: version,
                        };
                        this.$store.dispatch('getRevision', revisionPayload).then(() => {
                            var revisionDataFrom2020 = this.getRevisionData.filter(function (r) { return new Date(r.dateCreated) >= new Date('2020-01-01'); });

                            if (revisionDataFrom2020.length > 0) {
                                this.revisions.push(revisionDataFrom2020);
                            }
                            this.revisions.sort((a, b) => {
                                return new Date(b[0]?.dateCreated) - new Date(a[0]?.dateCreated);
                            });
                        });
                    });
                });
            },
            updateProductLine() {
                if (this.productLineParam) {
                    if (Object.keys(productLines)?.map(key => { return productLines[key] })?.find(pl => pl.name.toLowerCase() == this.productLineParam.toLowerCase())) {
                        this.form.productLine = Object.keys(productLines)?.map(key => { return productLines[key] })?.find(pl => pl.name.toLowerCase() == this.productLineParam.toLowerCase());
                    }
                }

                if (this.$route.query.productLine) {
                    this.form.productLine = this.productLines?.find(pl => pl.name.toLowerCase() == this.$route.query.productLine.toLowerCase())
                }
                if (!this.form.productLine) {
                    this.form.productLine = this.productLines[0]
                }
            },
            updateOemAddOn() {
                if (this.form.productLine.name.toLowerCase() !== 'loopcad') {
                    this.form.oemAddOn = null;
                    return;
                }
                if (this.$route.query.softwareOemId) {
                    this.form.oemAddOn = this.oems?.find(o => o.softwareInternalID == this.$route.query.softwareOemId)
                }
                if (!this.form.oemAddOn) {
                    this.form.oemAddOn = this.oems?.find(o => o.name == 'Generic');
                }
            },
            updateRoute() {
                let queryParams = {}
                if (this.form.productLine) {
                    queryParams.productLine = this.form.productLine?.name.toLowerCase()
                }

                if (this.form.oemAddOn) {
                    queryParams.softwareOemId = this.form.oemAddOn?.softwareInternalID
                }

                this.$router.replace({
                    path: this.$route.path,
                    query: queryParams,
                }).catch(err => { })
            },
        },
        computed: {
            ...mapState([
                'getRevisionPending',
                'getRevisionData',

                'getVersionsPending',
                'getVersionsData',

                'getOemsPending',
                'getOemsData',
            ]),
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            this.updateProductLine();
            this.getOEMs().then(() => {
                this.updateOemAddOn();
                this.updateRoute();
                this.getRevisions();
            });
        },
    }
</script>
<style scoped>

    .hoverShadow:hover {
        box-shadow: 0 1px 8px rgb(0 0 0 / 20%), 0 3px 4px rgb(0 0 0 / 14%), 0 3px 3px -2px rgb(0 0 0 / 12%);
    }

        .hoverShadow:hover .icon {
            transition: 0.15s;
            transform: scale(110%);
        }

    .img-revision-history {
        max-width: 100%;
        max-height: 55px;
        width: unset;
    }
</style>
